
<div class="featured-dish-container" [style.background-image]="getImage()">
  <div class="overlay"></div>
  <div class="cuisine-name-container">
    <img [src]="product.merchant?.profilePictureURL ?? 'assets/merchant-placeholder.svg'">
    <p class="cuisine-name">{{ product.merchant?.name ?? ''  }}</p>
  </div>
  <div class="product-name-div">
    <p class="dish-name">{{ product.name }}</p>
    <p class="dish-price">{{ product.price / 100 }} {{ product.currency }}</p>
  </div>
  <div class="view-profile-link" (click)="viewProduct()">
    <p i18n="@@viewDetails">View details</p>
  </div>
</div>
